module.exports = __webpack_public_path__ + "img/manage-active.adf9c7e2.svg";